export const LOAD_GENERIC_CASE_FORM = "LOAD_GENERIC_CASE_FORM";
